// Single QueryClient shared by the whole app. Module-scoped so re-renders
// of <App /> (we recreate the router on auth state change — see app.tsx)
// don't blow away in-flight queries.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale-while-revalidate: views render last-known data instantly and
      // the realtime layer re-invalidates whenever new rows arrive.
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
